<template>
  <div>
    <v-card elevation="2">
      <v-data-table
        disable-pagination
        v-model="selecteds"
        :headers="computedHeaders"
        :items="item_products"
        :show-select="role == 'stockiest' || role == 'admin' ? true : false"
        :hide-default-footer="true"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>List Produk</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="80%">
              <template
                v-if="permission.includes('Create Products')"
                v-slot:activator="{ on }"
              >
                <v-btn color="primary" small dark class="mb-2" v-on="on"
                  >Buat Produk</v-btn
                >
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="6" md="12">
                      <suggestions
                        placeholder="Items"
                        v-model="searchQuery"
                        :options="options"
                        :onItemSelected="onSearchItemSelected"
                        :onInputChange="onInputChange"
                      >
                        <div slot="item" slot-scope="props" class="single-item">
                          <template
                            v-if="props.item.Icon && props.item.Icon.URL"
                          >
                            <div
                              class="image-wrap"
                              :style="{
                                backgroundImage:
                                  'url(' + props.item.Icon.URL + ')',
                              }"
                            ></div>
                          </template>
                          <span class="name">{{ props.item.item_name }}</span>
                        </div>
                      </suggestions>
                      <!-- <v-text-field v-model="editedItem.name" label="Name"></v-text-field> -->
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="editedItem.description"
                        label="Description"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <div
                        class="
                          v-input v-input--is-label-active v-input--is-dirty
                          theme--light
                          v-text-field v-text-field--is-booted
                        "
                      >
                        <div class="v-input__control">
                          <div class="v-input__slot">
                            <div class="v-text-field__slot">
                              <label
                                for="customElement1"
                                class="v-label v-label--active theme--light"
                                style="
                                  left: 0px;
                                  right: auto;
                                  position: absolute;
                                "
                                >Harga Jual</label
                              >
                              <money
                                v-model="editedItem.harga_jual"
                                id="customElement1"
                              ></money>
                            </div>
                          </div>
                          <div class="v-text-field__details">
                            <div class="v-messages theme--light">
                              <div class="v-messages__wrapper"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- <v-text-field type="number" :disabled="isDisable" v-model="editedItem.harga_jual" label="Harga Jual"></v-text-field> -->
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <div
                        class="
                          v-input v-input--is-label-active v-input--is-dirty
                          theme--light
                          v-text-field v-text-field--is-booted
                        "
                      >
                        <div class="v-input__control">
                          <div class="v-input__slot">
                            <div class="v-text-field__slot">
                              <label
                                for="customElement2"
                                class="v-label v-label--active theme--light"
                                style="
                                  left: 0px;
                                  right: auto;
                                  position: absolute;
                                "
                                >Harga Beli</label
                              >
                              <money
                                v-model="editedItem.harga_beli"
                                id="customElement2"
                              ></money>
                            </div>
                          </div>
                          <div class="v-text-field__details">
                            <div class="v-messages theme--light">
                              <div class="v-messages__wrapper"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- <v-text-field type="number" :disabled="isDisable" v-model="editedItem.harga_beli" label="Harga Beli"></v-text-field> -->
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      <label>
                        <v-select
                          v-model="editedItem.type"
                          :items="productTypes"
                          label="Tipe Produk"
                          item-text="name"
                          item-value="id"
                          required
                        ></v-select>
                      </label>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      <label>
                        <v-select
                          v-model="editedItem.product_category_id"
                          :items="productCategories"
                          label="Kategori Produk"
                          item-text="name"
                          item-value="id"
                        ></v-select>
                      </label>
                    </v-col>
                    <v-col
                      v-if="editedItem.type == 'MANAGED_ALL'"
                      cols="12"
                      sm="6"
                      md="12"
                    >
                      <v-text-field
                        type="number"
                        v-model="editedItem.stock"
                        label="Jumlah Stok"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      v-if="editedItem.type == 'MANAGED_ALL'"
                      cols="6"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        type="datetime-local"
                        v-model="editedItem.start"
                        label="Start"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col
                      v-if="editedItem.type == 'MANAGED_ALL'"
                      cols="6"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        type="datetime-local"
                        v-model="editedItem.finish"
                        label="Finish"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      <label>Available on:</label>
                      <Multiselect
                        v-model="selectedInterfaces"
                        placeholder="Pilih interface"
                        track-by="name"
                        label="name"
                        :options="interfaces"
                        :multiple="true"
                        :close-on-select="false"
                        :hide-selected="true"
                      >
                        <template v-slot:noResult> No Result! </template>
                        <template v-slot:noOptions>
                          List interface is empty!
                        </template>
                      </Multiselect>
                    </v-col>
                    <v-col cols="12" sm="6" md="12" v-if="role == 'admin'">
                      <v-text-field
                        type="number"
                        v-model="editedItem.min_stock"
                        label="Minimum Stok (Threshold)"
                      ></v-text-field>
                    </v-col>
                    <!-- <v-col cols="12" sm="6" md="12">
                    <v-checkbox
                      v-model="isLapangan"
                      label="Services (Layanan/Persewaan)"
                    ></v-checkbox>
                  </v-col> -->
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="productImageModal" max-width="500px">
              <v-card>
                <v-card-title>
                  <span class="headline">Gambar Produk</span>
                </v-card-title>
                <v-card-text class="text-center">
                  <v-row v-if="listProductImages.length < 6">
                    <v-col cols="12" sm="6" md="12">
                      <v-file-input
                        accept="image/*"
                        label="Tambah Gambar Produk"
                        outlined
                        dense
                        hide-details="true"
                        ref="uploadImage"
                        @change="onUploadImage()"
                        v-model="fileGambarProduk"
                      ></v-file-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      v-for="image in listProductImages"
                      :key="image.id"
                      cols="6"
                      sm="3"
                      md="6"
                    >
                      <v-avatar tile size="100">
                        <img
                          class="pointer"
                          @click="
                            onClickImage(
                              baseUrl + '/' + image.location + '/' + image.name
                            )
                          "
                          :src="
                            baseUrl + '/' + image.location + '/' + image.name
                          "
                          alt="Product Images"
                        />
                      </v-avatar>
                      <br />
                      <v-btn
                        text
                        small
                        @click="onRemoveImage(image.id)"
                        color="error"
                        >Hapus Gambar Produk</v-btn
                      >
                      <!-- <v-btn text small @click="onRemoveImageProfile()" color="error">Hapus Foto Profil</v-btn> -->
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="assignInterfaceModalVisible"
              persistent
              max-width="500px"
              height="500px"
              scrollable
            >
              <v-card>
                <v-card-title class="headline"
                  >Tambah Interface ke Produk</v-card-title
                >
                <v-card-text style="height: 200px">
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <label>Available on:</label>
                      <Multiselect
                        v-model="selectedInterfaces"
                        placeholder="Pilih interface"
                        track-by="name"
                        label="name"
                        :options="interfaces"
                        :multiple="true"
                        :close-on-select="false"
                        :hide-selected="true"
                      >
                        <template v-slot:noResult> No Result! </template>
                        <template v-slot:noOptions>
                          List interface is empty!
                        </template>
                      </Multiselect>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="assignInterfaceModalVisible = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="saveAssignInterfaceModal"
                    >Save</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
          <v-row class="ml-2 mt-4">
            <v-col cols="3">
              <v-btn
                v-if="role == 'stockiest' || role == 'admin'"
                block
                depressed
                small
                color="primary"
                height="35px"
                @click="bulkEdit()"
                :disabled="selecteds.length > 0 ? false : true"
              >
                <v-icon>mdi-grease-pencil</v-icon>
                Bulk Edit
              </v-btn>
              <v-dialog v-model="bulkModalVisible" max-width="500px" persistent>
                <v-card>
                  <v-card-title> Bulk Edit </v-card-title>
                  <v-card-text>
                    <v-select
                      v-model="CategoryBulk"
                      :items="itemKategoriBulk"
                      label="Pilih Bulk"
                    ></v-select>
                    <v-select
                      v-model="editedItem.product_category_id"
                      :items="productCategories"
                      v-if="CategoryBulk == 'Bulk Kategori'"
                      label="Kategori Produk"
                      item-text="name"
                      item-value="id"
                    ></v-select>
                    <v-autocomplete
                      v-model="selectedInterfaces"
                      :items="interfaces"
                      v-if="CategoryBulk == 'Bulk Avaible On'"
                      item-value="id"
                      item-text="name"
                      chips
                      label="Avaible On"
                      multiple
                      solo
                    ></v-autocomplete>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="[(bulkModalVisible = false)]"
                      >Cancel</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="handleBulk"
                      >Bulk</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </template>
        <template v-slot:[`item.no`]="{ item }">
          {{
            item_products.indexOf(item) + 1 + (currentPage - 1) * pageSize + "."
          }}
        </template>
        <template v-slot:[`item.product_category`]="{ item }">
          {{
            item.product_category && item.product_category.name
              ? item.product_category.name
              : "UNDEFINED"
          }}
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-tooltip
            v-if="
              permission.includes('Update Products') &&
                ((item.status === 'PENDING' && role === 'stockiest') ||
                  (item.status === 'APPROVED' && role === 'admin'))
            "
            top
          >
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" v-on="on" @click="editItem(item)"
                >edit</v-icon
              >
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <a href="/pengeluaran" v-on="on">
                <i
                  class="fa fa-external-link-alt"
                  style="color: rgba(0, 0, 0, 0.54)"
                ></i>
              </a>
            </template>
            <span>Pengeluaran</span>
          </v-tooltip>
          <v-tooltip v-if="role === 'stockiest'" top>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" v-on="on" @click="addImage(item)"
                >image</v-icon
              >
            </template>
            <span>Tambah Gambar</span>
          </v-tooltip>
        </template>
        <template
          v-slot:[`item.status`]="{ item }"
          v-if="statusCanEditByRole.includes(role)"
        >
          <v-chip
            v-if="role != 'stockiest'"
            small
            class="ma-2"
            label
            :color="statusColor[item.status]"
            @click="changeStatusProduct(item, toggleStatusProduct[item.status])"
            >{{ item.status }}</v-chip
          >
          <v-chip
            v-else
            small
            class="ma-2"
            label
            :color="statusColor[item.status]"
            >{{ item.status }}</v-chip
          >
        </template>
        <template v-slot:[`item.status`]="{ item }" v-else>
          <v-chip small class="ma-2" label :color="statusColor[item.status]">{{
            item.status
          }}</v-chip>
        </template>
        <template v-slot:[`item.harga_jual`]="{ item }">
          {{ convertCurrency(item.harga_jual) }}
        </template>
        <template v-slot:[`item.harga_beli`]="{ item }">
          {{ convertCurrency(item.harga_beli) }}
        </template>
        <template v-slot:[`item.sell_price_latest`]="{ item }">
          {{ convertCurrency(item.sell_price_latest) }}
        </template>
        <template v-slot:[`item.purchase_price_latest`]="{ item }">
          {{ convertCurrency(item.purchase_price_latest) }}
        </template>
        <template v-slot:[`item.type`]="{ item }">
          {{ item.type.replace("_", " ") }}
        </template>
        <template v-slot:no-data>
          <span class="text-center">No data available.</span>
        </template>
      </v-data-table>

      <div style="padding: 20px" class="d-flex">
        <v-col class="d-flex" cols="12" sm="1">
          <small style="margin-top: 30px">Item show</small>
        </v-col>
        <v-col class="d-flex" cols="12" sm="1">
          <v-select
            v-model="pageSize"
            :items="pageSizes"
            @change="handlePageSizeChange"
            style="font-size: 10px"
          ></v-select>
        </v-col>
        <v-col class="d-flex" cols="12" sm="12">
          <v-pagination
            style="width: auto"
            v-model="currentPage"
            :length="totalPages"
            total-visible="10"
            next-icon="mdi-menu-right"
            prev-icon="mdi-menu-left"
            @input="handlePageChange"
          ></v-pagination>
          <small style="margin-top: 28px"
            >{{ from }}-{{ to }} of {{ totalData }}</small
          >
        </v-col>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import forEach from "lodash/forEach";
import slice from "lodash/slice";
import find from "lodash/find";
import isEmpty from "lodash/isEmpty";
import Multiselect from "vue-multiselect";
import itemTemplate from "@/components/ItemTemplate.vue";
import { formatCurrency } from "@/libs/number";

export default {
  components: {
    Multiselect,
  },
  data: () => ({
    searchQuery: "",
    selectedSearchItem: null,
    options: {
      placeholder: "Nama Produk",
    },
    itemTemplate,
    isLapangan: false,
    dialog: false,
    expand: false,
    role: "",
    permission: [],
    showError: false,
    headers: [
      {
        text: "No.",
        align: "left",
        value: "no",
      },
      {
        text: "Nama",
        align: "left",
        value: "name",
      },
      { text: "Stok", align: "center", value: "stock" },
      { text: "Sold", align: "center", value: "already_sold" },
      { text: "Min Stok", align: "center", value: "min_stock" },
      { text: "Description", value: "description" },
      { text: "Harga Jual", value: "harga_jual" },
      { text: "Harga Jual Terbaru", value: "sell_price_latest" },
      { text: "Harga Beli", value: "harga_beli" },
      { text: "Harga Beli Terbaru", value: "purchase_price_latest" },
      { text: "Kategori", value: "product_category" },
      { text: "Status", value: "status" },
      { text: "Product Type", value: "type" },
      { text: "Product Start", value: "start" },
      { text: "Product Finish", value: "finish" },
      { text: "Actions", value: "action", sortable: false },
    ],
    productCategories: [],
    productTypes: [
      {
        id: "MANAGED_STOCK",
        name: "STOCK LIMIT",
      },
      {
        id: "MANAGED_TIME",
        name: "TIME LIMIT",
      },
      {
        id: "UNMANAGE",
        name: "NO LIMIT",
      },
      {
        id: "MANAGED_ALL",
        name: "LIMITED",
      },
    ],
    item_products: [],
    item_items: [],
    interfaces: [
      {
        title: "Space Pirate",
        desc: "More space battles!",
        img: "static/posters/fleet.png",
      },
      {
        title: "Merchant",
        desc: "PROFIT!",
        img: "static/posters/trading_post.png",
      },
      {
        title: "Explorer",
        desc: "Discovering new species!",
        img: "static/posters/creatures.png",
      },
      {
        title: "Miner",
        desc: "We need to go deeper!",
        img: "static/posters/resource_lab.png",
      },
    ],
    //interfaces: ["PARKIR", "MOBILE", "POS"],
    selectedInterfaces: [],
    produk: "",
    selected: "",
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
    statusColor: {
      PENDING: "secondary",
      "PARTIAL APPROVE": "yellow",
      APPROVED: "primary",
    },
    statusCanEditByRole: ["admin", "accountant", "stockiest"],
    toggleStatusProduct: {
      PENDING: "APPROVED",
      "PARTIAL APPROVE": "PARTIAL APPROVE",
      APPROVED: "PENDING",
    },
    productImageModal: false,
    listProductImages: [],
    fileGambarProduk: null,
    selectedProduct: null,
    baseUrl: process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL,

    // assign Product Interface
    assignInterfaceModalVisible: false,
    selecteds: [],
    bulkModalVisible: false,
    itemKategoriBulk: ["Bulk Kategori", "Bulk Avaible On"],
    CategoryBulk: null,
    pageSizes: [10, 50, 100],
    currentPage: 1,
    totalPages: 0,
    pageSize: 10,
    from: 0,
    to: 0,
    totalData: 0,
  }),

  computed: {
    ...mapGetters({
      dataInterfaces: "product_interfaces/getProductInterfaces",
      dataItems: "products/getItems",
    }),

    formTitle() {
      return this.editedIndex === -1 ? "Buat Produk" : "Edit Produk";
    },
    computedHeaders() {
      let editedHeaders = this.headers;
      if (!this.statusCanEditByRole.includes(this.role)) {
        editedHeaders = this.headers.filter(
          (header) => header.value !== "status"
        );
      }
      if (!this.permission.includes("Update Products")) {
        editedHeaders = this.headers.filter(
          (header) => header.value !== "action"
        );
      }
      return editedHeaders;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions({
      createProducts: "products/createProducts",
      updateProducts: "products/updateProducts",
      deleteProducts: "products/deleteProducts",
      getProductById: "products/getProductById",
      uploadImage: "products/uploadImage",
      removeImage: "products/removeImage",
      getUserById: "user/getUserById",
      searchItem: "item/searchItem",
      getProductCategories: "product_categories/getProductCategories",
      dataProducts: "products/getProducts",
      bulkProduk: "products/bulkProduk",
    }),
    async handleBulk() {
      let id = [];
      this.selecteds.forEach(function tampil(element, index, array) {
        id.push(element.id);
      });
      let response = await this.bulkProduk({
        id,
        CategoriBulk: this.CategoryBulk,
        productKategori: this.editedItem.product_category_id,
        interface_id: this.selectedInterfaces,
      });

      if (response.data.success) {
        this.item_products = [];
        const dataProduk = await this.dataProducts(this.currentPage);
        forEach(dataProduk.data.attributes, (data) => {
          // console.log('data', data)
          data.harga_jual = Number(data.harga_jual);
          data.harga_beli = Number(data.harga_beli);
          data.purchase_price_latest = Number(data.purchase_price_latest);
          data.sell_price_latest = Number(data.sell_price_latest);
          data.already_sold = Number(data.already_sold);
          data.start = data.product_schedules[0]
            ? data.product_schedules[0].start
            : "-";
          data.finish = data.product_schedules[0]
            ? data.product_schedules[0].finish
            : "-";
          this.item_products.push(data);
        });

        this.bulkModalVisible = false;
        this.selecteds = [];
        return this.$notify({
          group: "custom-notification",
          type: "success",
          title: "Berhasil!",
          text: "Bulk Data Berhasil di lakukan",
        });
      }
    },
    async bulkEdit() {
      this.bulkModalVisible = true;
    },
    onClickImage(url) {
      window.open(url, "_blank");
    },
    async onRemoveImage(id) {
      try {
        const response = await this.removeImage(id);
        if (response.status === 200) {
          this.$notify({
            group: "custom-notification",
            type: "success",
            title: "Success!",
            text: "Hapus gambar produk berhasil!",
          });

          this.fileGambarProduk = null;
          this.listProductImages = [];
          const responseProduct = await this.getProductById(
            this.selectedProduct
          );
          forEach(
            responseProduct.data.attributes.product_attachment,
            (attachment) => {
              this.listProductImages.push(attachment);
            }
          );
        }
      } catch (e) {
        console.log(e);
      }
    },
    convertCurrency(total) {
      return "Rp. " + formatCurrency(total);
    },
    async initialize() {
      const userLogin = JSON.parse(window.localStorage.getItem("user_data"));
      this.role = userLogin.roles[0].name;
      this.permission = userLogin.permissions;
      const dataProduk = await this.dataProducts({
        page: this.currentPage,
        jum: this.pageSize,
      });
      this.totalPages = dataProduk.data.attributes.last_page;
      this.currentPage = dataProduk.data.attributes.current_page;
      this.from = dataProduk.data.attributes.from;
      this.to = dataProduk.data.attributes.to;
      this.totalData = dataProduk.data.attributes.total;
      forEach(dataProduk.data.attributes.data, (data) => {
        // console.log('data', data)
        data.harga_jual = Number(data.harga_jual);
        data.harga_beli = Number(data.harga_beli);
        data.purchase_price_latest = Number(data.purchase_price_latest);
        data.sell_price_latest = Number(data.sell_price_latest);
        data.already_sold = Number(data.already_sold);
        data.start = data.product_schedules[0]
          ? data.product_schedules[0].start
          : "-";
        data.finish = data.product_schedules[0]
          ? data.product_schedules[0].finish
          : "-";
        this.item_products.push(data);
      });

      const { data } = await this.getProductCategories();
      this.productCategories = data;
      this.interfaces = await this.dataInterfaces;
    },
    async onUploadImage() {
      try {
        if (this.fileGambarProduk != null) {
          const data = new FormData();
          data.append("product", this.fileGambarProduk);
          data.append("product_id", this.selectedProduct);

          const response = await this.uploadImage(data);
          if (response.status === 200) {
            this.$notify({
              group: "custom-notification",
              type: "success",
              title: "Success!",
              text: "Upload gambar produk berhasil!",
            });

            this.fileGambarProduk = null;
            this.listProductImages = [];
            const responseProduct = await this.getProductById(
              this.selectedProduct
            );
            forEach(
              responseProduct.data.attributes.product_attachment,
              (attachment) => {
                this.listProductImages.push(attachment);
              }
            );
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    async onInputChange(query) {
      this.editedItem.name = "";
      if (query === null || query === "") {
        return "";
      }
      let filter = {
        type: null,
        q: query,
      };
      const results = await this.searchItem(filter);
      return results.data.attributes;
    },
    onSearchItemSelected(item) {
      this.searchQuery = item.item_name;
      this.editedItem.name = item.item_name;
      this.editedItem.harga_jual = Number(item.harga_jual);
      this.editedItem.harga_beli = Number(item.harga_beli);
      this.selectedSearchItem = item;
    },

    async changeStatusProduct(item, status) {
      let editedItem = this.item_products.find(
        (item_product) => item_product.id === item.id
      );
      if (editedItem.type === "MANAGED_ALL") {
        editedItem.schedules = {
          start: editedItem.product_schedules[0].start,
          finish: editedItem.product_schedules[0].finish,
        };
      }
      const response = await this.updateProducts({
        ...editedItem,
        status: this.role == "admin" ? "APPROVED" : "PARTIAL APPROVE",
      });
      if (
        response &&
        response.status === 200 &&
        response.data &&
        response.data.attributes
      ) {
        editedItem.status = response.data.attributes[0].status;
      }
    },

    async editItem(data) {
      // const dataItem = await this.dataItems;
      // forEach(dataItem.data.attributes, data => {
      //   data.harga_jual = Number(data.harga_jual)
      //   data.harga_beli = Number(data.harga_beli)
      //   this.item_items.push(data)
      // })
      // this.selected = find(this.item_items, ['item_name', data.name])
      // if(this.selected == undefined){
      //   this.selected = {
      //     id: 0,
      //     item_name: data.name,
      //     qty: 0,
      //     submission_id: 0,
      //     product_id: 0,
      //     user_id: data.user_id,
      //     company_id: data.company_id,
      //     created_at: "",
      //     updated_at: "",
      //     harga_jual: data.harga_jual,
      //     harga_beli: data.harga_beli,
      //   }
      //   this.item_items.push(this.selected)
      // }
      let tempData = Object.assign({}, data)

      tempData.start = tempData.start.replace(" ", "T")
      tempData.finish = tempData.finish.replace(" ", "T")
      const currentInterfaces = tempData.product_interfaces
        ? tempData.product_interfaces
        : [];
      this.selectedInterfaces = currentInterfaces.map((interfaces) => {
        return {
          id: interfaces.id,
          name: interfaces.name,
        };
      });
      this.isLapangan = tempData.id_product_category == 6 ? true : false;
      this.editedIndex = this.item_products.indexOf(tempData);
      this.editedItem = Object.assign({}, tempData);
      this.dialog = true;
      this.searchQuery = tempData.name;
    },
    async addImage(data) {
      this.listProductImages = [];
      this.selectedProduct = data.id;
      // console.log('data', data)

      const response = await this.getProductById(data.id);
      // console.log('response', response)

      forEach(response.data.attributes.product_attachment, (attachment) => {
        this.listProductImages.push(attachment);
      });

      this.productImageModal = true;
    },

    async openAssignInterfaceModal(data) {
      this.editedItem = data;
      this.selectedInterfaces = this.editedItem.product_interfaces;
      this.assignInterfaceModalVisible = true;
    },

    async saveAssignInterfaceModal() {
      // console.log(this.editedItem)
    },

    // async deleteItem(item) {
    //   const index = this.item_products.indexOf(item);
    //   if(confirm("Apakah anda yakin menghapus produk ini?")){
    //      await this.deleteProducts(item.id)
    //      this.item_products.splice(index, 1);
    //   }
    // },

    close() {
      this.dialog = false;
      this.isLapangan == false;
      this.searchQuery = "";
      this.selectedInterfaces = "";
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    async save() {
      const interfaceIds = this.selectedInterfaces.map(
        (interfaces) => interfaces.id
      );
      this.editedItem.interface_ids = interfaceIds;
      if (this.editedIndex > -1) {
        try {
          // console.log(this.editedItem, 'this.editedItem')
          this.editedItem.name =
            this.editedItem.name == ""
              ? this.searchQuery
              : this.editedItem.name;
          this.editedItem.id_product_category = this.isLapangan == true ? 6 : 0;
          if (this.editedItem.type === "MANAGED_ALL") {
            this.editedItem.schedules = {
              start: this.editedItem.start,
              finish: this.editedItem.finish,
            };
          }
          const response = await this.updateProducts(this.editedItem);
          if (response) {
            response.data.attributes[0].harga_beli = Number(
              response.data.attributes[0].harga_beli
            );
            response.data.attributes[0].harga_jual = Number(
              response.data.attributes[0].harga_jual
            );
            response.data.attributes[0].already_sold = Number(
              response.data.attributes[0].already_sold
            );
            response.data.attributes[0].product_interfaces = this.selectedInterfaces;
            Object.assign(
              this.item_products[this.editedIndex],
              response.data.attributes[0]
            );
            this.$notify({
              group: "custom-notification",
              type: "success",
              title: "Success!",
              text: "Success update produk",
            });
          }
        } catch (e) {
          console.log(e);
        }
      } else {
        this.editedItem.name =
          this.editedItem.name == "" ? this.searchQuery : this.editedItem.name;
        this.editedItem.id_product_category = this.isLapangan == true ? 6 : 0;
        if (this.editedItem.type === "MANAGED_ALL") {
          this.editedItem.schedules = {
            start: this.editedItem.start,
            finish: this.editedItem.finish,
          };
        }
        const response = await this.createProducts(this.editedItem);
        if (!response) {
          return false;
        }
        response.data.attributes.harga_beli = Number(
          response.data.attributes.harga_beli
        );
        response.data.attributes.harga_jual = Number(
          response.data.attributes.harga_jual
        );
        response.data.attributes.product_interfaces = this.selectedInterfaces;
        this.item_products.splice(0, 0, response.data.attributes);
        this.$notify({
          group: "custom-notification",
          type: "success",
          title: "Success!",
          text: "Success create produk",
        });
      }
      this.close();
    },
    async handlePageChange(value) {
      this.item_products = [];
      this.currentPage = value;
      const dataProduk = await this.dataProducts({
        page: value,
        jum: this.pageSize,
      });
      this.totalPages = dataProduk.data.attributes.last_page;
      this.currentPage = dataProduk.data.attributes.current_page;
      this.from = dataProduk.data.attributes.from;
      this.to = dataProduk.data.attributes.to;
      this.totalData = dataProduk.data.attributes.total;
      forEach(dataProduk.data.attributes.data, (data) => {
        data.harga_jual = Number(data.harga_jual);
        data.harga_beli = Number(data.harga_beli);
        data.purchase_price_latest = Number(data.purchase_price_latest);
        data.sell_price_latest = Number(data.sell_price_latest);
        data.already_sold = Number(data.already_sold);
        data.start = data.product_schedules[0]
          ? data.product_schedules[0].start
          : "-";
        data.finish = data.product_schedules[0]
          ? data.product_schedules[0].finish
          : "-";
        this.item_products.push(data);
      });
    },
    async handlePageSizeChange(size) {
      this.item_products = [];
      this.pageSize = size;
      this.currentPage = 1;
      const dataProduk = await this.dataProducts({
        page: this.currentPage,
        jum: this.pageSize,
      });
      this.totalPages = dataProduk.data.attributes.last_page;
      this.currentPage = dataProduk.data.attributes.current_page;
      this.from = dataProduk.data.attributes.from;
      this.to = dataProduk.data.attributes.to;
      this.totalData = dataProduk.data.attributes.total;
      forEach(dataProduk.data.attributes.data, (data) => {
        data.harga_jual = Number(data.harga_jual);
        data.harga_beli = Number(data.harga_beli);
        data.purchase_price_latest = Number(data.purchase_price_latest);
        data.sell_price_latest = Number(data.sell_price_latest);
        data.already_sold = Number(data.already_sold);
        data.start = data.product_schedules[0]
          ? data.product_schedules[0].start
          : "-";
        data.finish = data.product_schedules[0]
          ? data.product_schedules[0].finish
          : "-";
        this.item_products.push(data);
      });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.pointer {
  cursor: pointer;
}
</style>
